export const HPDashboardRules = {
    standard: {
        showStartProject: true,
        showToDoSummary: false,
        showPipelineSummary: true,
        showComingSoon: false,
    },
    benjiView: {
        showStartProject: false,
        showToDoSummary: false,
        showPipelineSummary: false,
        showComingSoon: false,
    },
    suspendedCompliance: {
        showStartProject: false,
        showToDoSummary: false,
        showPipelineSummary: true,
        showComingSoon: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/config/app.dashboardRules.config.js